/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const IncognitoIcon = ({
  className,
  style,
  color = '#595959',
  onClick,
}: IconTypeProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(className)}
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.83402 4.16667C7.4836 4.16667 7.17062 4.38589 7.05086 4.71522L6.22555 6.98482C7.39673 6.77805 8.67388 6.66667 9.99996 6.66667C11.3261 6.66667 12.6032 6.77805 13.7744 6.98482L12.9491 4.71522C12.8294 4.38589 12.5164 4.16667 12.166 4.16667H7.83402ZM15.7148 7.44399L14.5154 4.14564C14.1561 3.15767 13.2172 2.5 12.166 2.5H7.83402C6.78276 2.5 5.8438 3.15767 5.48453 4.14564L4.28514 7.44399C3.44763 7.69932 2.70276 8.01181 2.08138 8.37278C1.68342 8.60398 1.54822 9.11399 1.77941 9.51192C2.01059 9.90992 2.52062 10.0451 2.91858 9.81392C4.40577 8.94997 6.98473 8.33333 9.99996 8.33333C13.0152 8.33333 15.5942 8.94997 17.0814 9.81392C17.4794 10.0451 17.9894 9.90992 18.2205 9.51192C18.4517 9.114 18.3165 8.60398 17.9185 8.37278C17.2972 8.01181 16.5523 7.69932 15.7148 7.44399ZM5.83331 11.6667C4.91283 11.6667 4.16664 12.4128 4.16664 13.3333C4.16664 14.2538 4.91283 15 5.83331 15C6.75378 15 7.49998 14.2538 7.49998 13.3333C7.49998 12.4128 6.75378 11.6667 5.83331 11.6667ZM2.49998 13.3333C2.49998 11.4924 3.99236 10 5.83331 10C7.15204 10 8.29192 10.7658 8.83246 11.8769C9.58388 11.5966 10.416 11.5966 11.1675 11.8769C11.708 10.7658 12.8479 10 14.1666 10C16.0076 10 17.5 11.4924 17.5 13.3333C17.5 15.1743 16.0076 16.6667 14.1666 16.6667C12.402 16.6667 10.9577 15.2956 10.841 13.5606C10.3231 13.2576 9.67688 13.2576 9.15904 13.5606C9.04221 15.2956 7.59788 16.6667 5.83331 16.6667C3.99236 16.6667 2.49998 15.1743 2.49998 13.3333ZM14.1666 11.6667C13.2462 11.6667 12.5 12.4128 12.5 13.3333C12.5 14.2538 13.2462 15 14.1666 15C15.0871 15 15.8333 14.2538 15.8333 13.3333C15.8333 12.4128 15.0871 11.6667 14.1666 11.6667Z"
      fill={color}
    />
  </svg>
);
